import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';

/* Danke-Seite nach der Stripe-Zahlung eines P1 Coachings (12.10.2026). Öffentlich, ohne Personendaten:
   fragt nur den Stand der Zahlung ab. Schlicht gehalten wie die übrigen öffentlichen Seiten. */
export default function CoachingBezahltPage() {
  const [params] = useSearchParams();
  const sitzung = params.get('sitzung');
  const [d, setD] = useState(null);
  const [fehler, setFehler] = useState(false);
  useEffect(() => {
    document.title = 'P1 Coaching';
    if (!sitzung) return;
    axios.get(`${process.env.REACT_APP_BACKEND_URL || ''}/api/coaching/oeffentlich/bestaetigen`, { params: { sitzung } })
      .then((r) => setD(r.data)).catch(() => setFehler(true));
  }, [sitzung]);
  const bezahlt = d && ['bezahlt', 'laufend'].includes(d.status);
  return (
    <main className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center px-5 py-12">
      <div className="w-full max-w-md text-center space-y-5">
        <img src="/logo-weiss-kompakt.png" alt="P1 Performance Center" className="mx-auto h-14 w-auto object-contain" />
        {params.get('abgebrochen') ? (
          <><h1 className="text-2xl font-bold">Zahlung abgebrochen</h1><p className="text-white/70">Es wurde nichts abgebucht. Der Link aus deiner Nachricht bleibt 24 Stunden gültig.</p></>
        ) : fehler || !sitzung ? (
          <><h1 className="text-2xl font-bold">Wir prüfen deine Zahlung</h1><p className="text-white/70">Die Zahlung konnte gerade nicht abgerufen werden. Du bekommst eine Bestätigung per E-Mail, sobald sie verbucht ist.</p></>
        ) : !d ? <p className="text-white/70">Einen Moment …</p> : bezahlt ? (
          <>
            <h1 className="text-3xl font-extrabold">Danke, das hat geklappt.</h1>
            <p className="text-white/80">{d.name}: {d.termine} {d.termine === 1 ? 'Termin' : 'Termine'} mit deinem Coach und dein Trainingsplan in der P1 App, {d.laufzeit_tage} Tage ab deinem ersten Termin.</p>
            {d.gym_inklusive && <p className="text-white/80">Gym &amp; Sauna sind für die Laufzeit dabei. Die Tür öffnest du mit der P1 App.</p>}
            <p className="text-white/80"><strong>So geht es weiter:</strong> Wir melden uns bei dir für deinen Starttermin. Die Bestätigung kommt per E-Mail.</p>
          </>
        ) : <><h1 className="text-2xl font-bold">Zahlung noch offen</h1><p className="text-white/70">Deine Zahlung ist noch nicht eingegangen. Sobald sie da ist, bekommst du eine E-Mail.</p></>}
        <p className="text-xs text-white/40">P1 Performance Center GmbH · Georg-Stieß-Straße 2 · 75181 Pforzheim · <a className="underline" href="/agb#coaching">Bedingungen</a></p>
      </div>
    </main>
  );
}
